//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { get } from "lodash";
import { updateProfile } from "@/model/javaApi/apis";
import { updateProfileEncrypted } from "@/model/javaApi/profile.encrypt";
export default {
  name: "update-information",
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: {
      type: Boolean,
    },
    profile: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      /** 合规：个人资料提交走加密接口，关闭则回退原明文逻辑 */
      enableProfileEncrypt: true,
      inEdit: false,
      formValues: {
        name: "",
        idCardNo: "",
      },
      validateError: "",
      focusEl: "",
    };
  },
  watch: {
    value(current, previous) {
      if (current && current != previous) {
        this.inEdit = false;
        this.formValues = {
          ...this.formValues,
          name: "",
          idCardNo: "",
        };
      }
    },
  },
  methods: {
    updateVisible(visible) {
      this.$emit("change", visible);
    },
    onConfirm() {
      if (this.inEdit) {
        // 提交
        if (!this.formValues.name) {
          this.validateError = "请填写正确的姓名";
          return;
        }
        if (!this.formValues.idCardNo) {
          this.validateError = "请填写正确的身份证号";
          return;
        }
        const submitProfile = this.enableProfileEncrypt
          ? updateProfileEncrypted
          : updateProfile;
        submitProfile({
          data: this.formValues,
          headers: { "Catch-Error_Self": true },
        })
          .then(() => {
            this.updateVisible(false);
            this.$emit("refreshProfile");
          })
          .catch((error) => {
            this.validateError = "填写的姓名与身份证信息不匹配";
          });
      } else {
        // 进入编辑
        this.inEdit = true;
      }
    },
    setFocus(eleName) {
      if (this.validateError) {
        this.validateError = "";
      }
      this.focusEl = eleName;
    },
    resetValue(name) {
      this.$set(this.formValues, name, "");
      try {
        this.$refs[name].focus();
      } catch (error) {}
    },
  },
};
